import styled from "styled-components";

export const StyledButton = styled.button`
    max-width: ${(props) => props.maxWidth};
    min-width: ${(props) => (props.isMobile ? "10px" : "120px")};
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px ${(props) => props.outlineColor};
    border-radius: 0.25rem;
    background-color: ${(props) => props.backgroundColor};
    color: ${(props) => props.color};
    font-size: 0.8rem;
    &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
`;
